export enum EligibilityResult {
	ElectricActive = 'ElectricActive',
	DNP = 'DNP',
	ElectricInactive = 'ElectricInactive',
	NoService = 'NoService',
	GasOnly = 'GasOnly',
	NotFound = 'NotFound',
}
